import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { IItemComboBaseDTO } from "../../../../interfaces/base/IBase";

const UseComboEstado = (isOpen: boolean) => {
    const [dataComboEstado, setDataComboEstado] = useState<IItemComboBaseDTO[]>([]);
    const comboBoxRefEstado = useRef<IComboBox>(null);

    const onClickComboEstado = () => comboBoxRefEstado.current?.focus(true);

    const _openOption = useCallback(
        () => comboBoxRefEstado.current?.focus(true),
        []
    );

    const _onkeyUpSearchEstado = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefEstado.current?.focus(false);
        } else {
            _openOption();
        }
    };

    const listarCombo = () => {
        setDataComboEstado([
            { key: 'Activo', text: "Activo" },
            { key: 'Inactivo', text: "Inactivo" }
        ]);
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    return {
        dataComboEstado,
        onClickComboEstado,
        _onkeyUpSearchEstado,
        comboBoxRefEstado
    };
}

export { UseComboEstado }
